import { render, staticRenderFns } from "./DraggableListsLayersItem.vue?vue&type=template&id=1b8ef91a&scoped=true&"
import script from "./DraggableListsLayersItem.vue?vue&type=script&lang=js&"
export * from "./DraggableListsLayersItem.vue?vue&type=script&lang=js&"
import style0 from "./DraggableListsLayersItem.vue?vue&type=style&index=0&id=1b8ef91a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8ef91a",
  null
  
)

export default component.exports